<template>
  <div>
    <label v-if="label"
           class="label"
           :class="{ 'label-sm': size === 'sm' }">{{ label }}
    </label>
    <b-input-group v-b-modal="table + '-search'">
      <b-form-input
          type="text"
          :value="value"
          readonly
          class="custom-search"
          :class="{ 'custom-search-sm': size === 'sm' }"
          @input="$emit('input', $event.target.value)"
      />
      <b-input-group-append>
        <button class="btn">
          <b-icon icon="search"></b-icon>
        </button>
      </b-input-group-append>
    </b-input-group>

    <!-- Reference search modal -->
    <esg-base-dashboard-modal :id="table + '-search'"
                              :size="modalSize">
      <esg-base-list :name="table"
                     :variable-height="true"
                     size="sm"
                     @rowClicked="onRowClicked">
        <template #actions>
          <esg-base-button size="sm"
                           @click="onReset">초기화
          </esg-base-button>
        </template>
      </esg-base-list>
    </esg-base-dashboard-modal>
    <!-- Reference search modal -->
  </div>
</template>

<script>
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

export default {
  name: "EsgBaseSearchBox",
  components: { EsgBaseDashboardModal, EsgBaseList, EsgBaseButton },
  props: {
    label: String,
    value: [String, Number],
    size: String,
    modalSize: {
      type: String,
      required: true
    },
    table: {
      type: String,
      required: true,
    },
  },
  beforeCreate() {
    // To prevent an error from using EsgBaseList recursively
    this.$options.components.EsgBaseList = require('@/components/esg/base/EsgBaseList.vue').default
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
    onChange($event) {
      this.$emit('change', $event.target.value);
    },
    onRowClicked(item) {
      this.$emit('rowClicked', item, this.table + '-search');
    },
    onReset() {
      this.$emit('rowClicked', {}, this.table + '-search');
    }
  },
}
</script>

<style scoped>
.label {
  font-size: 1rem;
  font-weight: 700;
  white-space: nowrap;
  margin-right: .5rem;
}

.label.label-sm {
  font-size: .75rem;
}

.custom-search {
  width: fit-content;
  padding: 0.3rem .8rem 0.3rem .8rem;
  height: 2rem;
  border-radius: 10px 0 0 10px !important;
  border: 1px solid #E7E7EE;
  background-color: #FFF !important;
  background-size: 20px 20px;
  font-family: NanumGothic, serif;
  color: #2E2E38;
  font-size: .875rem;
  font-weight: 400;
  text-overflow: ellipsis;
  cursor: pointer;
}

.custom-search:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-search[readonly] {
  background-color: #F6F6FA;
}

.custom-search + .input-group-append > button {
  background-color: #F6F6FA;
  border: 1px solid #E7E7EE;
  border-radius: 0 10px 10px 0;
}

.custom-search + .input-group-append > button:focus {
  background-color: #F6F6FA;
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-search + .input-group-append > button.btn > svg {
  color: #747480;
}

.custom-search-sm {
  padding: 0.2rem 1.25rem 0.2rem .4rem !important;
  height: 1.6rem !important;
  border-radius: 10px 0 0 10px !important;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: .75rem;
  font-weight: 400;
}

.custom-search.custom-search-sm + .input-group-append > button.btn {
  padding: 4px;
  height: 1.6rem;
  width: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-search.custom-search-sm + .input-group-append > button.btn > svg {
  height: calc(1.6rem - 12px);
  width: calc(1.6rem - 12px);
}

</style>